import { Activity, LineChart, Zap, Target } from "lucide-react";
import { Reveal, SectionLabel } from "./Reveal";
import { FEATURES } from "../../data";

const ICONS = {
  activity: Activity,
  "line-chart": LineChart,
  zap: Zap,
  target: Target,
};

export const Difference = () => (
  <section
    id="difference"
    data-testid="difference-section"
    className="relative border-t border-white/10 bg-[#050505] py-24 md:py-32"
  >
    <div className="mx-auto max-w-7xl px-6 md:px-12">
      <div className="mb-16 max-w-3xl">
        <Reveal>
          <SectionLabel>[ The Fuel Factory Difference ]</SectionLabel>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-5 font-heading text-4xl font-black uppercase leading-none tracking-tight text-white md:text-6xl">
            We don't guess.
            <br />
            <span className="text-white/40">We measure.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-6 max-w-xl font-body text-white/60 md:text-lg">
            Typical gyms sell effort. We sell a system — movement science and hard data
            engineered into a repeatable path from your current mechanics to your next
            level.
          </p>
        </Reveal>
      </div>

      <div className="grid grid-cols-1 border-l border-t border-white/10 sm:grid-cols-2 lg:grid-cols-4">
        {FEATURES.map((f, i) => {
          const Icon = ICONS[f.icon];
          return (
            <Reveal
              key={f.num}
              delay={i * 0.1}
              className="group relative border-b border-r border-white/10 p-8 transition-colors duration-300 hover:bg-white/[0.02]"
              data-testid={`feature-card-${i}`}
            >
              <div className="mb-8 flex items-start justify-between">
                <span className="flex h-12 w-12 items-center justify-center border border-white/15 text-[#00F0FF] transition-colors duration-300 group-hover:border-[#00F0FF]">
                  <Icon size={22} strokeWidth={1.5} />
                </span>
                <span className="font-mono text-xs text-white/25">{f.num}</span>
              </div>
              <h3 className="font-heading text-2xl font-bold uppercase tracking-tight text-white">
                {f.title}
              </h3>
              <p className="mt-3 font-body text-sm leading-relaxed text-white/55">
                {f.desc}
              </p>
              <span className="absolute bottom-0 left-0 h-px w-0 bg-[#00F0FF] transition-all duration-500 group-hover:w-full" />
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);

export default Difference;
